import { FC } from 'react'
import { Block } from '_BRIGHT_/components'

export const CenteredBlock: FC = ({ children }) => (
  <Block palette="baseTwo" paddingTop="5xl" paddingBottom="5xl">
    {children}
  </Block>
)
